<smallstack-form [schema]="data()?.schema" [value]="currentValues()" (valueChange)="setValues($event)">
  <smallstack-form-table [compactMode]="true"></smallstack-form-table>
</smallstack-form>
<div class="flex flex-row gap-1 justify-end" [ngClass]="{ 'dialog-actions': widgetTreeService.dialogRef }">
  @if (widgetTreeService.dialogRef) {
    <button class="btn btn-outline btn-sm" (click)="widgetTreeService.dialogRef.close()">Abbrechen</button>
  }
  <button class="btn btn-primary btn-sm" [loadingFn]="saveConfiguration()">Speichern</button>
</div>
